import APIService from "./APIService";

export default {
    async getAll() {
        const res = await APIService.apiCall().get("areas-concessao/get-areas-concessao");
        return res.data;
    },
    async getAllForAdd() {
        const res = await APIService.apiCall().get("areas-concessao/get-areas-concessao-add");
        return res.data;
    },
    async update(postData) {
        const res = await APIService.apiCall().put("areas-concessao/update", postData);
        return res.data;
    },
    async desvincular(id) {
        const res = await APIService.apiCall().delete(`areas-concessao/desvincular/${id}`);
        return res.data;
    },
};
